import React from 'react';
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import {modalClose} from "../genericFunctions";
import SlideOver, {SlideOverProps} from "../../generic/SlideOver";
import AssessmentAttachmentsTable, {
    AssessmentAttachmentTableProps
} from "../../../pages/consumers/assessments/components/AssessmentAttachmentsTable";


interface OwnProps extends SlideOverProps, AssessmentAttachmentTableProps {}

type Props = OwnProps;

// @ts-ignore
const AssessmentAttachmentsTableModal = NiceModal.create<Props>(({onClose, header, ...rest}) => {
    const modal = useModal()

    const handleClose = (e) => {
        modalClose(e, modal, onClose)
    }

    return (
        <SlideOver onClose={handleClose} open={modal.visible} afterClose={modal.remove} title={header}>
            <AssessmentAttachmentsTable {...rest}/>
        </SlideOver>
    )
})

export default AssessmentAttachmentsTableModal;
